export default __webpack_public_path__ + "static/media/elalamein.cbd2ce3d.jpg";